import { render, staticRenderFns } from "./PL_features_module_two.vue?vue&type=template&id=a9b83ea8&"
import script from "./PL_features_module_two.vue?vue&type=script&lang=js&"
export * from "./PL_features_module_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports